export default __webpack_public_path__ + "static/media/eject.1a60410f.svg";